const accordionScrollTop = () =>{
    if(document.querySelector('.accordion-item')){
        document.addEventListener('shown.bs.collapse', ev =>{
            if(!ev.target.closest('.accordion-item')) return;
            let acc = ev.target.closest('.accordion-item');
            let parent = acc.parentElement;
            let scrollOffset = parent.scrollTop + acc.offsetTop;
            /*window.scroll({
                top: scrollOffset - 100,
                left: 0,
                behavior: "smooth"
            })*/
            acc.scrollIntoView();
        })
    }
}
export default accordionScrollTop;